import { Routes, Route } from 'react-router-dom'
import Recipes from './production/Recipes'
import ProductionOrders from './production/ProductionOrders'

export default function Production() {
  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <Routes>
        <Route index element={<ProductionOrders />} />
        <Route path="recipes" element={<Recipes />} />
        <Route path="orders" element={<ProductionOrders />} />
        <Route path="finished" element={<div>Productos Terminados</div>} />
      </Routes>
    </div>
  )
}
